import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LabelRequest } from 'src/app/wings-mobile/models/receiving/label/label-request.model';
import { StagingRequest } from 'src/app/wings-mobile/models/receiving/staging/staging-request.model';
import { LabelResponse } from 'src/app/wings-mobile/models/receiving/label/label-response.model';
import { ReceivingRequest } from 'src/app/wings-mobile/models/receiving/receiving/receiving-request.model';
import { CheckStagingResquest } from '../../models/receiving/staging/check-staging-resquest.model';

@Injectable({
	providedIn: 'root'
})
export class InboundService {

	httpOptions = { headers: new HttpHeaders({ 'Content-type': 'application/json' }) };

	constructor(private http: HttpClient) {
		this.http = http;
	}

	getCheckReceivingGroup(request: LabelRequest): Observable<LabelResponse> {
		const URL = environment.inbound_url + '/api/v1/staging/checkPreReceivingGroup';

		return this.http.post<LabelResponse>(URL, request);
	}

	getCheckStaging(request: CheckStagingResquest): Observable<any> {
		const URL = environment.inbound_url + '/api/v1/staging/checkStagingLocation';

		return this.http.post(URL, request);
	}

	postProcess(request: ReceivingRequest): Observable<any> {
		const URL = environment.inbound_url + '/api/v1/staging/process';

		return this.http.post(URL, request);
	}

	postProcessPrint(request: ReceivingRequest): Observable<any> {
		const URL = environment.inbound_url + '/api/v1/staging/process/print';

		return this.http.post(URL, request);
	}

}
